import validateIsEmail from './validateIsEmail';

export default email => {
  const localPart = validateIsEmail(email) ? email.split('@')[0] : '';
  return localPart;
};
